import { isDocumentContent } from './domUtils';
import { findClosestAnchorNode } from './findClosestAnchorNode';

export class AnchorNode {
    private _identifier: string = '';
    private _index: number = -1;
    private _documentContent: number = -1; // 1 = true, 0 = false, -1 = uncached.

    public constructor(
        public readonly parent: AnchorNode,
        public readonly node: Element,
        public readonly children: AnchorNode[],
    ) { }

    public all(): AnchorNode[] {
        // One liner: return this.children.reduce((state, cur) => state.concat(cur.all()), [this as AnchorNode]);
        const results: AnchorNode[] = [];
        let nodeCurrent: AnchorNode = this;
        let idxChild = 0;
        for (; ; ) {
            results.push(nodeCurrent);
            for (; nodeCurrent !== this && idxChild >= nodeCurrent.children.length; nodeCurrent = nodeCurrent.parent) {
                idxChild = nodeCurrent.parent.children.indexOf(nodeCurrent) + 1;
            }
            if (idxChild >= nodeCurrent.children.length) {
                break;
            }
            nodeCurrent = nodeCurrent.children[idxChild];
            idxChild = 0;
        }
        return results;
    }

    public findClosestByNode(node: Node | Element): AnchorNode {
        return this.findByNode(findClosestAnchorNode(node));
    }

    public findByNode(node: Node | Element): AnchorNode {
        // One liner: return node && this.children.reduce((state, cur) => state || cur.findDomElement(node), null);
        if (!node) { return; }
        let nodeCurrent: AnchorNode = this;
        let idxChild = 0;
        for (; ; ) {
            if (nodeCurrent.node === node) {
                return nodeCurrent;
            }
            for (; nodeCurrent !== this && idxChild >= nodeCurrent.children.length; nodeCurrent = nodeCurrent.parent) {
                idxChild = nodeCurrent.parent.children.indexOf(nodeCurrent) + 1;
            }
            if (idxChild >= nodeCurrent.children.length) {
                break;
            }
            nodeCurrent = nodeCurrent.children[idxChild];
            idxChild = 0;
        }
    }

    public selfOrAncestorDocumentContent() {
        for (let node = this as AnchorNode; node; node = node.parent) {
            if (node.documentContent) {
                return node;
            }
        }
    }

    public get documentContent() {
        return this._documentContent !== -1
            ? this._documentContent === 1
            : (this._documentContent = isDocumentContent(this.node) ? 1 : 0) === 1;
    }

    public get num(): number {
        if (this._index !== -1) {
            return this._index;
        } else if (!this.parent) {
            return this._index = 1;
        } else {
            return this._index = this.selectorNum();
        }
    }

    public hasIdenticalSiblings(): boolean {
        return !this.parent
            ? false
            : this.parent.children.some((cur) => cur.identifier === this.identifier && cur !== this);
    }

    public get identifier(): string {
        return this._identifier !== '' ? this._identifier : (this._identifier = this.selectorId() || this.selectorCss() || this.selectorName() || 'unknown');
    }

    public get path(): string {
        if (this.hasIdenticalSiblings()) {
            return `${(this.identifier[0] !== '#' && this.parent ? this.parent.path + '/' : '')}${this.identifier}[${this.num}]`;
        } else {
            return `${(this.identifier[0] !== '#' && this.parent ? this.parent.path + '/' : '')}${this.identifier}`;
        }
    }

    private selectorId() { return this.node.id && `#${this.node.id}`; }
    private selectorCss() { return this.node.className && ('.' + this.node.className.replace(/[ ]+/g, '.')); }
    private selectorName() { return this.node.localName; }
    private selectorNum() {
        let counter = 0;
        for (let i = 0, ii = this.parent.children.length; i < ii; i++) {
            if (this.parent.children[i] === this) {
                return counter + 1;
            }
            if (this.parent.children[i].identifier === this.identifier) {
                counter++;
            }
        }
        throw new Error(`selectorNum unable to find parent-child`);
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/anchor/AnchorNode.tsx